import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-selector-input',
  templateUrl: './file-selector-input.component.html',
  styleUrls: ['./file-selector-input.component.scss']
})
export class FileSelectorInputComponent implements OnInit {

  @Input() placeholder: string;
  @Input() path: string;
  @Input() fullPath = "";
  @Input() download = false;

  constructor() { }

  ngOnInit() {
  }

}
